var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.188 0H1.81201C1.23926 0 0.774414 0.464844 0.774414 1.0376V2.00049L6.38297 5.73999C6.75789 5.98901 7.2421 5.98901 7.61564 5.73999L13.2256 2.00049V1.0376C13.2256 0.464844 12.7607 0 12.188 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.99999 6.4423C6.64168 6.4423 6.28474 6.33854 5.97208 6.12964L0.774414 2.66406V8.96297C0.774414 9.53572 1.23926 10.0006 1.81201 10.0006H12.188C12.7607 10.0006 13.2256 9.53572 13.2256 8.96297V2.66406L8.02791 6.12964C7.71524 6.33854 7.35831 6.4423 6.99999 6.4423Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5e06169a33ffb3f9f18ddc9ef0ef6686.svg";
export { ForwardRef as ReactComponent };